<template>
  <div class="image-grid image-grid-2">
    <figure v-for="image in imagesArray">
      <NuxtImg :src="imageUrl(image.src)" type="webp" placeholder loading="lazy" :alt="image.alt" width="370" height="230" />
    </figure>
  </div>
</template>

<script setup>
const props = defineProps({
  images: {
    type: String,
    required: true
  }
})

const imagesArray = ref([]);

onMounted(() => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(props.images, 'text/html');
  const imgElements = doc.querySelectorAll('img');
  imgElements.forEach(img => {
    imagesArray.value.push({
      src: img.getAttribute('src'),
      alt: img.getAttribute('alt')
    });
  });
});

const imageUrl = computed(() => {
  return (image) => {
    return 'https://img.rewards.flights/signed/dpr:2/rs:fill:370:230:1/' + btoa(image);
  }
});

</script>